import { useNavigate } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import users from 'modules/core/store/collections/users'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import NewLeave from 'modules/timeoff/components/NewLeave'

const NewLeavePage = () => {
  const navigate = useNavigate()
  const employee = users.current.employee

  const onClose = () => {
    // Since we can reach this page from both Employees List and Calendar page,
    // and this page is under Dashboard, we need to navigate back to the previous page.
    navigate(-1)
  }

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <NewLeave
      currentEmployee={employee}
      showEmployeeSelector
      onClose={onClose}
      bulkAdd
      contractVersions={contractVersions}
      loading={loading}
    />
  )
}

export default NewLeavePage
